import { render, staticRenderFns } from "./tabpage.vue?vue&type=template&id=303fc624&scoped=true&"
import script from "./tabpage.vue?vue&type=script&lang=js&"
export * from "./tabpage.vue?vue&type=script&lang=js&"
import style0 from "./tabpage.vue?vue&type=style&index=0&id=303fc624&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303fc624",
  null
  
)

export default component.exports